import axios from 'axios';
import { uiAppName } from '@nova/core';
import { neutronUrl } from '@/config';

const version = import.meta.env.PACKAGE_VERSION;

const client = axios.create({
  baseURL: neutronUrl,
  headers: {
    'X-UI-AppName': uiAppName.COMET,
    'X-UI-Version': version
  }
});

export default client;
